module.exports = __webpack_public_path__ + "img/p1.660c66c8.png";